import { render, staticRenderFns } from "./ForcePop.vue?vue&type=template&id=5af78ae8&scoped=true"
import script from "./ForcePop.vue?vue&type=script&lang=js"
export * from "./ForcePop.vue?vue&type=script&lang=js"
import style0 from "./ForcePop.vue?vue&type=style&index=0&id=5af78ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af78ae8",
  null
  
)

export default component.exports